export default "__VITE_ASSET__CcylOftg__"